import { render, staticRenderFns } from "./FbShow.vue?vue&type=template&id=0ce0b01e&scoped=true&"
import script from "./FbShow.vue?vue&type=script&lang=js&"
export * from "./FbShow.vue?vue&type=script&lang=js&"
import style0 from "./FbShow.vue?vue&type=style&index=0&id=0ce0b01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce0b01e",
  null
  
)

export default component.exports